module.exports = __webpack_public_path__ + "img/email.a8be8f44.svg";